<template>
  
  <div>
    <keep-alive>
      <router-view/>
    </keep-alive>
    </div>
</template>
<script>
if (window.chrome && window.chrome.inspect) {
    window.chrome.inspect();
}
</script>
<style>
*{
  margin: 0;
  padding: 0;
}
body{
  /* background-color: #f3f3f3; */
}
/* 添加自定义 Toast 样式 */
:deep(.van-toast) {
    font-size: 0.3733rem !important;
    padding: 0.2667rem 0.4rem !important;
}

:deep(.van-toast__text) {
    font-size: 0.3733rem !important;
}

/* 顶部导航栏样式 */
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 1.1733rem;
  background: #FFFFFF;
  padding: 0 .4rem;
  box-sizing: border-box;
  /* margin-bottom: .2667rem;
  border-radius: .2rem; */
  /* box-shadow: 0 .0267rem .1333rem rgba(0, 0, 0, 0.1); */
}

.nav-back img,
.nav-right img {
  width: .2133rem;
  height: .3733rem;
}

.nav-title {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: .4267rem;
  color: #000000;
}

.nav-back {
  width: .6667rem;
  height: .6667rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
